<template>
    <div class="detail_wrap">
        <!-- <div class="banner">
            <img src="../images/detailbanner.png" width="100%">
        </div> -->
        <div class="container content_wrap clearfix">
            <div class="menus_wrap" v-if="list.length">
                <div class="menutitle">{{title[0]}}</div>
                <ul class="menu">
                    <li :class="{active: item.active}" @click="getSecondList(item)" v-for="item in list">
                        <a>{{item.title}}</a>
                        <ul class="submenu" v-if="item.open">
                            <li :class="{ active: sub.active }" v-for="sub in item.childList" @click.stop="getThirdList(item.id, sub.id)">{{sub.title}}</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- 动态组件 -->
            <template v-if="componentType == 1">
                <message :title="title" :columnId="columnId" @change="gotoArticle"></message>
            </template>
            <template v-if="componentType == 2">
                <article-component :title="title" :article-resp="articleResp"></article-component>
            </template>
        </div>
    </div>
</template>
<script>
import message from '../components/message.vue'
import articleComponent from '../components/article.vue'

export default {
    components: {
        message,
        articleComponent
    },
    data() {
        return {
            list: [],
            childData: {
                type: 'child',
                parent_id: '-1'
            },
            articleData: {
                id: '1'
            },
            componentType: 0, //0父栏目 1子栏目 2文章组件
            articleResp: {},
            title: [],
            columnId: '',
            isRefresh: false   // 是否刷新二级菜单列表
            // title: {
            //     parent: '',
            //     child: ''
            // }
        }
    },
    watch: {
        $route(val) {
            this.articleResp = {};
            this.init();
            this.setTitle();
            this.backTop();
        }
    },
    created() {
        this.init();
        this.setTitle();
        window.scrollTo(0, 0);
    },
    mounted() {
        this.backTop();
    },
    methods: {
        backTop() {
            if (window.sessionStorage.getItem('top') == '1') {
                if (window.pageYOffset) window.pageYOffset = 0;
                if (document.documentElement.scrollTop) document.documentElement.scrollTop = 0;
                if (document.body.scrollTop) document.body.scrollTop = 0;
                window.sessionStorage.setItem('top', '0');
            }
        },
        //获取一级菜单
        async setTitle() {
            let nav = window.sessionStorage.getItem('nav');
            let firstId = this.$route.params.firstId;

            if (nav) {
                nav = window.JSON.parse(nav);

                this.title[0] = nav.filter(value => {
                    return value.parent_id == this.$route.params.firstId
                })[0].parenttitle;
            } else {
                let res = await this.$api.base.getNavigationList({ type: 'parent', parent_id: '' });

                this.title[0] = res.repBody.filter(value => {
                    return value.id == firstId
                })[0].title;
            }
        },
        async init() {
            let { firstId, secondId, thirdId, articleId } = this.$route.params;

            //先获取左边栏目
            this.childData.parent_id = this.$route.params.firstId;

            let res = await this.$api.base.getNavigationList(this.childData);

            res.repBody.forEach(item => {
                item.active = item.id == secondId ? true : false;
                item.open = false;

                if (item.childList && item.childList.length) {
                    item.childList.forEach(sub => {
                        sub.active = sub.id == thirdId ? true : false;

                        if (sub.id == thirdId) {
                            item.open = true;
                        }
                    })
                }
            })

            this.list = res.repBody;

            if (secondId == null) {
                // this.list[0].active = true;

                this.$router.push({
                    name: 'SecondList',
                    params: {
                        firstId,
                        secondId: this.list[0].id
                    }
                })
            }

            if (articleId == null) { //栏目
                //没有指定栏目列表ID 默认跳转到第一个栏目
                this.componentType = 1;

                let name = this.$route.name;

                this.columnId = name === 'SecondList' ? secondId : thirdId;

            } else { //调用文章接口
                this.componentType = 2;
                this.articleData.id = this.$route.params.articleId;
                let res = await this.$api.base.getArticleById(this.articleData);
                this.articleResp = res.repBody[0];
            }
        },
        getSecondList(obj) {
            if (obj.childList && obj.childList.length) {
                obj.open = !obj.open;
                this.list.forEach(item => {
                    if (item.id != obj.id) {
                        item.open = false;
                    }
                    item.active = false;
                })
                obj.active = true;
            } else {
                this.$router.push({
                    name: 'SecondList',
                    params: {
                        firstId: this.$route.params.firstId,
                        secondId: obj.id
                    }
                })
            }
        },
        getThirdList(secondId, thirdId) {
            let { firstId } = this.$route.params;

            this.$router.push({
                name: 'ThirdList',
                params: {
                    firstId,
                    secondId,
                    thirdId
                }
            })
        },
        gotoArticle(articleId) {

            let { firstId, secondId, thirdId = 0 } = this.$route.params;

            let name = 'Article', opts = { firstId, secondId, thirdId, articleId };

            this.$router.push({
                name,
                params: opts
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.detail_wrap {
    padding-top: 30px;
    background: url(../images/index_bottom.jpg) bottom center / 100% auto no-repeat;
    .content_wrap {
        min-height: 400px;
        padding-bottom: 20px;
    }

    .menus_wrap {
        width: 196px;
        display: inline-block;
        float: left;
        .menutitle {
            width: 196px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            color: #fff;
            border-radius: 6px 6px 0 0;
            background: url(../images/menu_bg.png) 0 0 / 100% auto no-repeat;
        }
        .menu {
            border: 1px solid #eaeaea;
            border-top: 0;
            border-radius: 0 0 6px 6px;
            color: #666;
            background: white;
            >li {
                border-bottom: 1px solid #eaeaea;
                text-align: center;
                font-size: 12px;
                line-height: 50px;
                box-sizing: border-box;
                cursor: pointer;
                &:last-child {
                    border-bottom: 0;
                }
                &.active {
                    a {
                        color: red;
                    }
                }
            }
            .submenu {
                li {
                    text-align: center;
                    height: 50px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0 5px;
                    line-height: 50px;
                    background: #ffeeee;
                    cursor: pointer;
                    &:last-child {
                        span {
                            border-bottom: 0;
                        }
                    }
                    span {
                        display: block;
                        margin: 0 10px;
                        border-bottom: 1px dotted #eaeaea;
                    }
                    &.active {
                        color: red;
                    }
                }
            }
        }
    }
}
</style>